module.exports = {"TXTWCL_Place_Bet":{"id":"TXTWCL_Place_Bet","defaultMessage":"Postavi ulog","track":"Place Bet"}}